<template>
  <div class="container">
    <div class="content">
      <div class="title">{{getArticleDetail.title}}</div>
      <div class="text">
        <p v-html="content"></p>
      </div>
      
      <div class="content_item" v-for="(item ,index) in courses" :key="index">
        <img class="badge_img" v-if="item.is_tejia" :src='kc7Img' alt="">
        <img class="content_img" :src='item.image' alt="">
        <div class="column">
          <div class="mid_title">{{item.course_name}}</div>
          <div class="rower">
            <div class="content_mid">
              <!-- <div class="mid_title">{{item.course_name}}</div> -->
              <div class="mid_text">{{item.description}}</div>
            </div>
            <div class="content_right">
              <div class="content_right_num">
                <img class="content_right_num_icon" :src='kc6Img' alt="">
                <div class="content_right_num_text">{{item.virtual_study}}人学过</div> 
              </div>
              <div class="content_right_btn" @click="detail(item.url)">查看详情</div>
            </div>
          </div>
        </div>
        
      </div>
     
    </div>
    <div class="bottom" v-if="mask">
      <div class="bottom_content">
        <div class="bottom_mid">
          <div class="bottom_content_text">剩余70%，{{getArticleDetail.order_num}}同学已学习，获得方式</div>
          <div class="bottom_content_btn">
            <div class="btn">￥{{getArticleDetail.price}}元</div>
            <div v-if="this.getArticleDetail.invite_status=='1'" @click="toShare" class="btn">邀请{{getArticleDetail.invite_number}}位好友助力免费看</div>
          </div>
        </div>
        
        <div :class="[getSelectedCoupon.coupon_user_id!=null?'box':'box_null']">
          <div v-if="getSelectedCoupon.coupon_user_id!=null"  class="moneyfont">使用优惠卷</div>
          <div v-if="getSelectedCoupon.coupon_user_id!=null" class="box_right">
            <div v-if="getSelectedCoupon.use_type=='1'" :class="[ischose?'moneyfont_chose':'moneyfont']">-￥<span :class="[ischose?'moneyBig':'unmoneyBig']" >{{getSelectedCoupon.reduce}}</span></div>
            <div v-if="getSelectedCoupon.use_type=='2'" :class="[ischose?'moneyfont_chose':'moneyfont']"><span :class="[ischose?'moneyBig':'unmoneyBig']">{{getSelectedCoupon.discount}}</span>折优惠</div>
            <img class="iconimg"  v-if="ischose" :src="choseImg" alt="">
            <img class="iconimg" v-if="!ischose" :src="unchoseImg" alt="">
          </div>
        </div>
        <div class="box1">
          <div class="box_left">
            <div  v-if="ischose" class="box_left_text">合计：<span style="color: #B3212D;font-size:18px">￥{{getSelectedCoupon.pay_price}}元</span></div>
            <div  v-if="!ischose" class="box_left_text">合计：<span style="color: #B3212D;font-size:18px">￥{{getArticleDetail.price}}元</span></div>
            <div v-if="getSelectedCoupon.use_type=='1'&&ischose" class="box_left_text">已使用优惠卷，节省{{getSelectedCoupon.reduce}}元</div>
            <div v-if="getSelectedCoupon.use_type=='2'&&ischose" class="box_left_text">已使用优惠卷，已打{{getSelectedCoupon.discount}}折优惠</div>
            <div v-if="!ischose" class="box_left_text">未使用优惠卷</div>
          </div>
          <div class="btn1" @click="buy">购买</div>
        </div>
      </div>
    </div>
    <div class="mask"  v-if="ismask">
      <img class="user_icon1" :src='shareImg' alt="">
      <img class="user_icon" @click="toShare" :src='knowImg' alt="">
    </div>
  </div>
</template>
<style scoped>
.column{
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  box-sizing: border-box;
  width: calc(100% - 120px) ;
}
.rower{
  display: flex;
  flex-direction: row;
}
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  background-color: #fff;
  color: rgb(34,34,34);
}
.mask{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  top: 0;
  left: 0;
}
.bottom_mid{
  height: calc(48vh - 100px);
  display: flex;
  align-items: center;
  flex-direction: column;
}
.moneyBig{
  font-size: 18px;
  color: #B3212D;
}
.unmoneyBig{
  font-size: 18px;
  color: rgb(34,34,34);
}
.box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 15px;
  height: 38px;
  line-height: 38px;
  margin-top: 20px;
  /* background-color: #FFF; */
  border-bottom:1px solid #e7e7e7;
  border-top:1px solid #e7e7e7;
}
.box_null{
  height: 30px;
  /* background-color: #FFF; */
  border-bottom:1px solid #e7e7e7;
}
.box1{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 15px;
  height: 48px;
  /* background-color: #FFF; */
  align-items: center;
 }
.box_left{
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.box_left_text{
  font-size: 12px;
  flex: 1;
  color: rgb(34,34,34);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 18px;
}
.box_right{
  display: flex;
  align-items: center;
}
.moneyfont{
  font-size: 14px;
  margin-right: 5px;
}
.moneyfont1{
  font-size: 14px;
}
.moneyfont_chose{
  font-size: 14px;
  margin-right: 5px;
  color: #B3212D;
}
.iconimg{
  width: 20px;
  height: 20px;
}
.content{
  width: 100%;
  background-color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  padding-bottom: 60px;
}
.title{
  font-size: 16px;
  line-height: 25px;
  font-weight: bold;
  color: rgb(34,34,34);
  margin-top: 15px;
  margin-bottom: 15px;
}
.user{
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  border-bottom:1px solid #e7e7e7;
}
.user_right{
  margin-left: 12px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  line-height: 20px;
}
.user_icon1{
      width: 250px;
    position: relative;
    right: -260px;
  transform: translateX(-50%);
  top:-10px
}
.user_icon{
  width: 200px;
  position: relative;
  right: -250px;
  transform: translateX(-50%);
  top:-25px
}
.font{
  font-size: 12px;
  color: rgb(34,34,34);
}
.text{
  line-height: 20px;
}
.bottom{
    position: fixed;
    /* background-color: rgba(0,0,0,.3); */
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}
.bottom_content{
    /* background-color: #ffffff; */
    background-image: linear-gradient(rgba(219,219,219,0.95),rgba(219,219,219,1),rgba(219,219,219,1),rgba(219,219,219,1));
    position: absolute;
    width: 100%;
    /* padding-top:calc(70vh - 250px); */
    bottom: 0;
    left: 0;
}
.bottom_content_text{
    font-size: 14px;
    color: #222;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 30px;
    font-weight: bold;

}
.bottom_content_btn{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.btn{
    background-color: #b3212d;
    color: #fff;
    font-size: 14px;
    border-radius: 14px;
    padding: 5px 9px;
    margin-right: 15px;
}
.btn1{
  background-color: #b3212d;
  color: #fff;
  font-size: 14px;
  border-radius: 14px;
  padding: 5px 9px;
  margin-right: 15px;
  width: 60px;
  height: 18px;
  text-align: center;
  line-height: 18px;
}
.content_item{
  width: 100%;
  height: 90px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 15px;
  position: relative;
  display: flex;
  flex-direction: row;
}
.content_img{
  width: 150px;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  flex: 7;
}
.content_mid{
  /* margin-left: 12px; */
  flex: 8;
  align-items: center;
    display: flex;
}
.content_right{
  flex: 5;
  display :flex;
  flex-direction :column;
  align-items: center;
  justify-content :flex-end;
}
.mid_title{
  font-weight: 600;
  font-size: 14px;
  color: rgb(34,34,34);
  margin-top :5px;
  margin-bottom :5px;
  line-height: 24px;
 text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
}
.mid_text{
  font-size: 12px;
  color:#1b1243; 
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content_right_btn{
    width:  90px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background-color: #B3212D;
    color: #fff;
    border-radius: 24px;
    font-size: 12px;
    margin-bottom :5px;
    margin-top :5px
}
.content_right_num{
  display :flex;
  flex-direction :row;
  justify-content :center;
  align-items :center
}
.content_right_num_icon{
  width :12px;
  height :12px;
  margin-right :2px;
}
.content_right_num_text{
  font-size: 12px;
  color: #879AA7;
  margin-top :1px;
}
.badge_img{
   width: 55px;
  height: 55px;
  position: absolute;
    right: -3px;
    top: -3px;
}
</style>

<script>
import { getIndexDetail ,buy,getSign} from '../apollo/apollo'
import wx from 'weixin-js-sdk';
import { MessageBox } from 'mint-ui';
export default {
  components: {
    
  },
  data() {
    return {
      shareImg:'./static/imgs/share.png',
      knowImg:'./static/imgs/know.png',
      getArticleDetail:{},//干货详情
      getSelectedCoupon:{},//优惠卷数据
      mask:true,
      content:'',//干货内容
      courses:[],
      kc6Img:'./static/imgs/kc6.png',
      kc7Img:'./static/imgs/kc7.png',
      choseImg:'./static/imgs/chose.png',
      unchoseImg:'./static/imgs/unchose.png',
      ischose:true,//是否选中
      params:{},//购买验证
      sign:{},//权限包
      ismask:false,
      article_id:0,

    }
  },
  computed:{
    
  },
  created() {
    this.init()
  },
  mounted(){
 
  },
  methods: {
    init(){
      document.title=this.$store.state.title;
      this.article_id=sessionStorage.getItem('article_id')*1
      getIndexDetail({id:this.article_id}).then(res=>{
        this.getArticleDetail=res.data.getArticleDetail
        this.getSelectedCoupon=res.data.getSelectedCoupon
        if(this.getArticleDetail.all_content==''){
          this.mask=true;
          this.content=this.getArticleDetail.part_content;
        }else{
          this.mask=false;
          this.content=this.getArticleDetail.all_content
        }
        this.courses=res.data.getArticleDetail.courses
        this.getAuthority()
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    //获取权限包
    getAuthority(){
      var code=sessionStorage.getItem('code')
      var user_id=sessionStorage.getItem('user_id')
      getSign({url:window.location.href.split("#")[0]}).then(res=>{
        let that = this;
        that.Sign=res.data.getSign
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: that.Sign.appId, // 必填，公众号的唯一标识
            timestamp: that.Sign.timestamp, // 必填，生成签名的时间戳
            nonceStr:that.Sign.nonceStr, // 必填，生成签名的随机串
            signature:that.Sign.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay','updateAppMessageShareData','updateTimelineShareData']
        });

          wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
            if(that.getArticleDetail.all_content==''){//当进入分享页面
              var urlLink='https://screen.xiaoyima.work/index.html?user_id='+user_id+'&article_id='+that.article_id+'&title='+encodeURIComponent(that.getArticleDetail.title)+'&state=123'+'#/share'
            }else{
              var urlLink='https://screen.xiaoyima.work/index.html?article='+that.article_id+'&state=123'+'#/login'
            }
            
            var data={
              title:that.getArticleDetail.share_title, // 分享标题
              desc:that.getArticleDetail.share_desc, // 分享描述
              link: urlLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:that.getArticleDetail.share_img_url, // 分享图标
            }
            wx.updateAppMessageShareData(data)
            wx.updateTimelineShareData(data)
          });
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    //查看详情
    detail(url){
      window.location.href=url
    },
  //  chose(){
  //     this.ischose=!this.ischose
  //   },
    toShare(){
      this.ismask=!this.ismask
    },
    buy(){
        MessageBox.confirm('是否确认购买','提示').then(action => {
          var id=0;
          if(this.ischose){
            id=this.getSelectedCoupon.coupon_id
          }else{
            id=0
          }
          var formDate={
            article_id:this.article_id,
            price:this.getArticleDetail.price,
            pay_price:this.getSelectedCoupon.pay_price,
            coupon_user_id:this.getSelectedCoupon.coupon_user_id,
            coupon_id:id,
          }
          buy(formDate).then(res=>{
            if(JSON.parse(res.data.createOrder).code==200){
              let that = this;
              this.params=JSON.parse(res.data.createOrder).data
              wx.ready(function () {
                wx.chooseWXPay({
                  appId:that.params.appId, //公众号名称，由商户传入
                  timestamp:Number(that.params.timestamp), //时间戳，自1970年以来的秒数
                  nonceStr:that.params.nonceStr, //随机串
                  package:that.params.package,
                  signType:that.params.signType, //微信签名方式：
                  paySign:that.params.paySign,//微信签名
                  complete:function(res){              
                    that.init()
                  },
                  success:function(res){              
                    //  MessageBox.confirm('支付成功！','提示').then(action => {
                      that.init()
                    // })         
                  },
                  error:function(res){     
                    //  MessageBox.confirm('支付失败！','提示').then(action => {
                      that.init()
                    // })
                  },
                  cancel:function(res){
                    that.init()
                  }
                });
              });
            }else{
              this.showOneBtnAlert(JSON.parse(res.data.createOrder).msg)
            }
          })
          .catch(err=>{
              this.msgManage(err)
            })
        }).catch(()=>{   
           
        });
      
    },

  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/indexdetail.vue